import React, { Component } from 'react';
import './Promo.css';

import ConnectionsService from '../../../core/services/ConnectionsService';
import AuthService from '../../../core/services/AuthService';

import Dialog from '../../shared/dialog/Dialog';
import FiltersBox from '../../shared/filters-box/FiltersBox';
import TableHeader from '../../shared/table/table-header/TableHeader';
import TableEditor from '../../shared/table/table-editor/TableEditor';
import TableItemCounter from '../../shared/table/table-item-counter/TableItemCounter';
import TableItem from '../../shared/table/table-item/TableItem';
import SvgIcon from '../../shared/svg-icon/SvgIcon';
import Searcher from '../../shared/searcher/Searcher';

import LoadingBox from '../../shared/loading-box/LoadingBox';
import { ItemFilter, ParamsBuilder, ContainsAll } from '../../../core/helpers';

import { store } from 'react-notifications-component';

import ReactPlayer from 'react-player';
import ReactPaginate from 'react-paginate';
import swal from '@sweetalert/with-react';

import DropPromo from '../../shared/drop-promo/DropPromo';

import defaultThumbnail from '../../../assets/images/icons/icn_video_default_thumbnail.png';

class Promo extends Component {

    constructor(props) {
        super(props);
        this.functionBinder = this.functionBinder.bind(this);
        this.functionBinder(this);
        this.state = {
            promo: [],
            videos: [],
            promos: [],
            videos_ids: [],
            promos_ids: [],
            newVideos: [],
            newPromos: [],
            iconFill: "#7F60EA",
            hover: true,
            isCheckedAll: false,
            isEdit: false,
            isAjax: false,
            secundaryView: false,
            listObj: {},
            listObjBase: '',
            promoVideosBase: '',
            modalShow: false,
            buttonShow: false,
            isUpdating: false,
            showPlayer: false,
            showPlayerDetails: false,
            playPromo: [],
            playingUrl: '',
            playingName: '',
            playingIndex: 0,
            itemId:'',
            searchTerm: '',
            searchBy: 'videos',
            perPage: 50,
            currentPage: 0,
            pageCount: 0,
            totalVideos: 0,
            searchTermPL: '',
            perPagePL: 50,
            currentPagePL: 0,
            pageCountPL: 0,
            totalPromo: 0,
            perPageVideosPromo: 50,
            currentPageVideosPromo: 0,
            pageCountVideosPromo: 0,
            totalVideosPromo: 0,
            showFilters: false,
            searchTags: [],
            isVideoAjax: false,
            isSearching: false,
            isCheckedAllPromo: false,
            checkAllSearch: [],
            checkedVideos: [],
            isSaveDisabled: true,
            modalShowDrop: false,
            modalShowDropDrop: false,
            modalShowEdit: false,
            buttonShowDrop: false,
            buttonShowEdit: false,
            isUploading: false,
            promoInfo: {
                title:'',
                timelapse:'',
                devices_id: [],
                days: [],
                start_time: '',
                end_time:'',
                file: []
            },
            devices:[]
        }

        this.notificationConfig = {
            title: "Atención!",
            message: 'Título, autor y archivo de video son requeridos',
            type: "warning",
            insert: "bottom",
            container: "bottom-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
                duration: 1000,
                onScreen: true
            }
        };
    }

    functionBinder(value) {
        this.getPromo = this.getPromo.bind(value);
        this.getVideosById = this.getVideosById.bind(value);
        this.deleteChild = this.deleteChild.bind(value);
        this.deleteAll = this.deleteAll.bind(value);
        this.checkAll = this.checkAll.bind(value);
        this.checkAllPromo = this.checkAllPromo.bind(value);
        this.newPromo = this.newPromo.bind(value);
        this.checkChild = this.checkChild.bind(value);
        this.clickChild = this.clickChild.bind(value);
        this.checkNewChild = this.checkNewChild.bind(value);
        this.editItem = this.editItem.bind(value);
        this.handleAddVideos = this.handleAddVideos.bind(value);
        this.handleSubmitPromo = this.handleSubmitPromo.bind(value);
        this.setModalShow = this.setModalShow.bind(value);
        this.editorBtnClicked = this.editorBtnClicked.bind(value);
        this.getAllVideos = this.getAllVideos.bind(value);
        this.handleInputChange = this.handleInputChange.bind(value);
        this.checkIfCanSave = this.checkIfCanSave.bind(value);
        this.handleSignout = this.handleSignout.bind(value);
        this.hidePlayer = this.hidePlayer.bind(value);
        this.changePlayingUrl = this.changePlayingUrl.bind(value);
        this.onVideoEnds = this.onVideoEnds.bind(value);
        this.handleVideoSearch = this.handleVideoSearch.bind(value);
        this.handlePromoSearch = this.handlePromoSearch.bind(value);
        this.handlePageClick = this.handlePageClick.bind(value);
        this.handlePageClickPL = this.handlePageClickPL.bind(value);
        this.handlePageClickVideosPromo = this.handlePageClickVideosPromo.bind(value);
        this.filtersToggle = this.filtersToggle.bind(value);
        this.handleTags = this.handleTags.bind(value);
        this.handleSubmit = this.handleSubmit.bind(value);
        this.handleChildren = this.handleChildren.bind(value);
        this.setModalShowDrop = this.setModalShowDrop.bind(value);
        this.getDevicesList = this.getDevicesList.bind(value);

        this.playVideo = this.playVideo.bind(value);
    }

    playVideo(video) {
        if (video && video.filename && video.title) {
            this.setState({
                showPlayerDetails: true,
                playingUrl: video.filename,
                playingName: video.title
            });
        }
    }

    handleTags(value) {
        let searchTags = value.tags;

        this.setState({isCheckedAllPromo: false, searchTags, currentPage: 0}, () => {
            this.getAllVideos(this.state.searchTerm);
        });
    }

    handleAddVideos(data) {}

    prepareAddAll() {

        let objSend = {
            search: [],
            videos: []
        };

        if (this.state.videos.length && this.state.videos_ids.length) {

            let videosIds = JSON.parse(JSON.stringify(this.state.videos_ids));
            videosIds = videosIds.map((vid) => {
                vid.deleted = false;
                return vid;
            });

            let deletedVideos = this.state.videos.filter(video => video.deleted);
            if (deletedVideos.length) {

                deletedVideos.forEach((deleted) => {
                    let item = videosIds.filter(ids => deleted.id === ids.id);

                    if (item.length) {
                        item.forEach((value) => {
                            value.deleted = true;
                        });

                    }

                });

            }

            let videosPush = videosIds.filter(vid => !vid.deleted);

            if (videosPush.length) {
                videosPush.forEach((video, index) => {
                    let obj = {id: `${video.id}`, orden: index + 1};
                    if (video['pv_id']) {
                        obj['pv_id'] = video['pv_id'];
                    }
                    objSend.videos.push(obj);
                });

            }
        }

        if (this.state.checkedVideos.length) {

            this.state.checkedVideos.forEach((videoID) => {
                let item = this.state.videos.filter(video => video.id === videoID);

                if (!item.length) {
                    let obj = {id: videoID.toString(), pv_id:null, orden: 0};

                    objSend.videos.push(obj);
                }

            });
        }

        if (objSend.videos.length) {
            objSend.videos.forEach((video, index) => {
                video.orden = index + 1;
            });

            let videosDeleted = ItemFilter(this.state.videos, 'deleted', true);

            if (videosDeleted.length) {
                videosDeleted.forEach((deleted) => {
                    let items = objSend.videos.filter(video => videosDeleted.id === video.id);

                    if (items.length) {
                        let index = objSend.videos.indexOf(items[0]);

                        if (index >= 0) {
                            objSend.videos.splice(index, 1);
                        }
                    }
                });

            }
        }

        if(!this.state.isIndividual && this.state.checkAllSearch.length) {
            objSend.search = this.state.checkAllSearch;
        }

        return objSend;
    }

    filtersToggle() {
        this.setState({showFilters: !this.state.showFilters});
    }

    componentDidMount() {
        this.getPromo("");
    }

    editorBtnClicked(id) {
        this.setState({newPromos: []});
        // this.getAllVideos("");

        this.setModalShowDrop(true);
    }

    setModalShow(value) {
        this.setState({
            isCheckedAllPromo: false,
            searchTags: [],
            checkAllPromo: [],
            checkedVideos: [],
            modalShow: value,
            searchTerm: "",
            currentPage: 0
        });
    }

    editItem(event,id) {
        let item = ItemFilter(this.state.promo, 'itemId', id);

        if(item.length) {
            this.setState({promoID: item[0].id, secundaryView: true, isEdit: true, listObj: item[0], listObjBase: JSON.stringify(item[0])});
            this.getVideosById(item[0].itemId,null);
        }
    }

    newPromo() {
        this.setState({promos:[]});
        let promo = {
            count_videos: 0,
            id: -1,
            name: "",
            itemId: "-1",
            total_duration: "00:00:00"
        }
        // this.setState({secundaryView: true, isEdit: false, listObj: promo, listObjBase: JSON.stringify(promo)});
        this.setState({listObj: promo, listObjBase: JSON.stringify(promo)});

        this.setState({newPromos: []});

        this.setModalShowDrop(true);
    }

    componentDidCatch(error, info) {
        console.log(error, info);
    }

    getPromo(text) {
        this.setState({isSearching: true}, () => {

            let searchTerm = text.trim() !== "" ? `&s=${text}`:'';

            ConnectionsService.get(`promolist?page=${this.state.currentPagePL + 1}${searchTerm}`).then((response) => {
                let pageCountPL = 0;
                let totalPromo = 0;
                console.log(response);
                if(response.data && response.data.promolist.length) {
                    response.data.promolist.forEach((promo) => {
                        promo.itemId = promo.id.toString();
                    });

                    if (response.data.total > 0){
                        pageCountPL = Math.ceil(response.data.total / this.state.perPagePL)
                        totalPromo = response.data.total;
                    }
                }
                let promo = response.data.promolist.map(obj => obj);
                promo.map(promo => promo.isChecked = false);
                this.setState({isSearching:false, promo, pageCountPL, totalPromo});
            },(error) => {
                console.log(error);
                // if(error.response.data) {
                //     if(!error.response.data.auth){
                //         this.handleSignout();
                //     }
                // }
            });

        });
    }

    handleSignout() {
        AuthService.handleSignout();
        window.location.href = '/login';
    }

    handleVideoSearch(text) {
        this.setState({isCheckedAllPromo:false, searchTerm: text, currentPage: 0}, () => {
            this.getAllVideos(text);
        });

    }

    handlePromoSearch(text) {
        this.setState({searchTermPL: text, currentPagePL: 0});
        this.getPromo(text);
    }

    handlePageClick = (data) => {
        this.setState({ currentPage: data.selected }, () => {
            this.getAllVideos(this.state.searchTerm);
        });
    }

    handlePageClickPL = (data) => {
        this.setState({ currentPagePL: data.selected }, () => {
            this.getPromo(this.state.searchTermPL);
        });
    }

    handlePageClickVideosPromo = (data) => {
        this.setState({ currentPageVideosPromo: data.selected }, () => {
            this.getVideosById(this.state.promoID,null);
        });
    }

    getAllVideos(text, callBack) {
        this.setState({isVideoAjax: true}, () => {

            let parameters = [
                {'page': this.state.currentPage + 1},
                {'s': text}
            ];

            if (this.state.promoID) {
                parameters.push({playpromo_id: this.state.promoID});
            }

            if (this.state.searchTags.length) {
                parameters.push({'tags[]': this.state.searchTags});
            }

            ConnectionsService.get(`video${ParamsBuilder(parameters)}`).then((response) => {
                let pageCount = 0;
                let totalVideos = 0;

                if(response.data && response.data.videos.length) {
                    response.data.videos.forEach((video) => {
                        video.itemId = video.id.toString();
                    });

                    if (response.data.total > 0){
                        pageCount = Math.ceil(response.data.total / this.state.perPage)
                        totalVideos = response.data.total;
                    }
                }

                let newVideos = response.data.videos.map(obj => obj);
                newVideos.map(video => video.isChecked = this.state.checkedVideos.indexOf(video.id) >= 0 ? true:false);

                let validated = this.validateCheckAll();

                if (this.state.isCheckedAllPromo || validated.contained){
                    this.setState({newVideos}, () => {
                        this.checkAllPromo(true, null, null, () => {
                            this.setState({isVideoAjax:false, pageCount, totalVideos}, () => {
                                if (callBack) {
                                    callBack();
                                }
                            });
                        });
                    });
                } else {
                    this.setState({isVideoAjax:false, newVideos, pageCount, totalVideos}, () => {
                        if (callBack) {
                            callBack();
                        }
                    });
                }

            }, error => console.log(error));

        });
    }

    getVideosById(id, total = null, callBack) {
            this.setState({isSearching: true}, () => {

                let urlString = total ? `promolist/${id}`:`promolist/${id}?page=${this.state.currentPageVideosPromo + 1}`;
            ConnectionsService.get(urlString).then((response) => {
                let pageCountVideosPromo = 0;
                let totalVideosPromo = 0;


                if(response.data && response.data.videos.length) {
                    response.data.videos.forEach((video) => {
                        video.itemId = video.id.toString();
                    });

                    if (response.data.video_count > 0) {
                        pageCountVideosPromo = Math.ceil(response.data.video_count / this.state.perPageVideosPromo);
                        totalVideosPromo = response.data.video_count;
                    }
                }
                let videos = response.data.videos.map(obj => obj);
                videos.map(video => video.deleted = false);
                let videos_ids = response.data.videos_ids.map(id => id);

                this.setState({
                    isSearching: false,
                    pageCountVideosPromo,
                    totalVideosPromo,
                    videos,
                    videos_ids,
                    promoVideosBase: JSON.stringify(videos)},

                    () => {
                        if (callBack) {
                            callBack();
                        }
                    }
                );

            }, error => console.log(error));

        });
    }

    deleteChild(event, id) {

        swal({
            title: "¿Estás seguro?",
            text: "Una vez borrada, no podrás recuperar tu promo",
            icon: "warning",
            buttons: ["No borrar!", "Borrar!"],
            dangerMode: true,
        })
        .then((willDelete) => {
            if (willDelete) {
                this.setState({isAjax: true});
                ConnectionsService.delete(`promolist/${id}`)
                    .then((response) => {
                        this.getPromo("");
                        this.setState({isAjax: false});
                        store.addNotification({
                            title: "¡Listo!",
                            message: "Promo eliminada correctamente",
                            type: "success",
                            insert: "bottom",
                            container: "bottom-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 1000,
                                onScreen: true
                            }
                        });
                    }, (e) => {
                        this.setState({isAjax: false});
                        store.addNotification({
                            title: "Error!",
                            message: "Error al intantar eliminar promo",
                            type: "danger",
                            insert: "bottom",
                            container: "bottom-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 1000,
                                onScreen: true
                            }
                        });
                    });
            }
        });
    }

    deleteVideo(index) {
        let videos = this.state.videos;
        this.setState({videos: []});
        videos[index].deleted = !videos[index].deleted;
        this.setState({videos}, () => {
            this.checkIfCanSave();
        });
    }

    checkIfCanSave() {
        var value = true;

        if (this.state.videos.length) {
            this.state.videos.forEach((video) => {
                if(video.deleted) {
                    value = false
                }
            });
        }

        if(JSON.stringify(this.state.listObj) !== this.state.listObjBase) {
            if(this.state.listObj.name) {
                value = false
            }
        }
        this.setState({isSaveDisabled: value});
    }

    deleteAll() {
        if(this.state.promo) {
            let items = ItemFilter(this.state.promo, 'isChecked', true);
            if(items.length) {
                let ids = '';
                items.forEach((item, index) => { ids += index < items.length - 1 ? `${item.id},`:`${item.id}`});
                ConnectionsService.delete(`promolist/?d=${ids}`).then((response) => {
                    this.checkAll(false);
                    this.notificationConfig.type = 'success';
                    this.notificationConfig.message = 'Promos Eliminadas';
                    store.addNotification(this.notificationConfig);
                    this.getPromo("");
                }, (error) => {
                    this.notificationConfig.type = 'danger';
                    this.notificationConfig.message = 'Error al intentar eliminar promos';
                });
            }
        }
    }

    checkAll(value) {
        let promo = this.state.promo;
        if(promo.length) {
            promo.map(promo => promo.isChecked = value);
            this.setState({promo});
            this.setState({isCheckedAll:value});
        }
    }

    validateCheckAll() {

        let contained = false;
        let index = -1;

        if (this.state.checkAllSearch.length) {
            let items = this.state.checkAllSearch.filter(check => check.s === this.state.searchTerm);
            if(items.length) {

                items.forEach((item, i) => {
                    let response = ContainsAll(item.tags, this.state.searchTags) && item.tags.length === this.state.searchTags.length;

                    if (response) {
                        contained = true;
                        index = i;
                    }
                });

            }
        }

        return {contained: contained, index: index};
    }

    checkAllPromo(value, excluded_id = null, included_id = null, callBack) {

        let checkAllSearch = this.state.checkAllSearch;
        let validated = this.validateCheckAll();
        let index = validated.index;

        if (value) {

            if(!validated.contained) {
                checkAllSearch.push({
                    s: this.state.searchTerm,
                    tags: this.state.searchTags,
                    excluded_ids: excluded_id ? [excluded_id]:[]
                });
                index = checkAllSearch.length - 1;
            } else {

                if (included_id) {
                    let itemInclude = checkAllSearch[index].excluded_ids.indexOf(included_id);
                    if(itemInclude >= 0){
                        checkAllSearch[index].excluded_ids.splice(itemInclude,1);
                    }
                } else if (excluded_id) {
                    checkAllSearch[index].excluded_ids.push(excluded_id);
                }
            }
        } else {

            if (validated.contained) {
                checkAllSearch.splice(index, 1);
                index = -1;
            }
        }

        let newVideos = this.state.newVideos;

        if(newVideos.length && !excluded_id) {

            newVideos.map(video => video.isChecked = value);
        }

        this.setState({checkAllSearch, newVideos, isCheckedAllPromo:value}, () => {
            if (callBack) {
                callBack();
            }
        });
    }

    checkChild (value) {
        let id = value.target.id.replace("select",'');
        let promoCopy = JSON.parse(JSON.stringify(this.state.promo));
        let item = ItemFilter(promoCopy, 'itemId',id);
        if(item.length) {
            item[0].isChecked = value.target.checked;
            this.setState({promo: promoCopy});
        }
        if(!value.target.checked){
            this.setState({isCheckedAll:false});
        }
    }

    clickChild(value) {
        // this.editItem(value,value)
    }

    getDevicesList(callBack) {
        ConnectionsService.get('device').then((response) => {
            console.log(response);
            if (response.data && response.data.length) {
                this.setState({devices: response.data}, () => {
                    callBack();
                });
            }
        });
    }

    checkNewChild (value) {

        let id = value.target.id.replace("select",'');
        let newVideos = JSON.parse(JSON.stringify(this.state.newVideos));
        let item = ItemFilter(newVideos, 'itemId',id);
        let checked = value.target.checked;
        if(item.length) {
            item[0].isChecked = checked;
            let checkedVideos = this.state.checkedVideos;

            if (checked) {
                checkedVideos.push(item[0].id);
            } else {

                let checkedIndex = checkedVideos.indexOf(item[0].id);
                checkedVideos.splice(checkedIndex, 1);
            }

            this.setState({newVideos, checkedVideos}, () => {
                if (this.state.isCheckedAllPromo) {
                    if (!checked) {
                        this.checkAllPromo(true, item[0].id, null);
                    } else {
                        this.checkAllPromo(true, null, item[0].id);
                    }
                }
            });
        }
    }

    handleSubmitPromo () {

        if(JSON.stringify(this.state.listObj) !== this.state.listObjBase || this.state.checkedVideos.length || this.state.checkAllSearch.length || !this.state.isSaveDisabled) {
            if(this.state.listObj.name) {

                this.setState({modalShow: false, isSearching: true}, () => {
                    let objEnvio = this.prepareData();
                    ConnectionsService.addPlaypromo(objEnvio,this.state.isEdit).then((response) => {

                        if(response.playPromoInfo.data && response.playPromoInfo.data.id) {
                            objEnvio.id = response.playPromoInfo.data.id;

                            let objSend = this.prepareAddAll();


                            objSend.id = response.playPromoInfo.data.id;
                            ConnectionsService.addVideos(objSend,this.state.isEdit).then((response) => {
                                this.setState({isVideoAjax: false, isSaveDisabled: true}, () => {

                                    this.getVideosById(this.state.promoID, null, () => {
                                        this.getPromo("");
                                    });
                                    this.notificationConfig.message = "Promo actualizada";
                                    this.notificationConfig.type = "success";
                                    store.addNotification(this.notificationConfig);

                                });
                            }, (error) => {
                                this.setState({isVideoAjax: false}, () => {
                                    this.getVideosById(this.state.promoID, null, () => {
                                        this.getPromo("");
                                    });
                                    this.notificationConfig.message = "Error al intentar guardar la promo";
                                    this.notificationConfig.type = "danger";
                                    store.addNotification(this.notificationConfig);
                                });
                            });

                        }

                    }, (error) => {
                        this.setState({isSearching: false}, () => {
                            this.notificationConfig.message = "Error al intentar guardar la promo";
                            this.notificationConfig.type = "danger";
                            store.addNotification(this.notificationConfig);
                        });
                    });
                });



            } else {
                this.notificationConfig.message = "Debes darle un nombre a tu promo";
                store.addNotification(this.notificationConfig);
            }

        }
    }

    showPlayerModal(event, id) {
        this.setState({playingUrl: '', playingName: '', playingIndex: 0});
        this.getVideosById(id, 'total', () => {
            if(this.state.videos.length && this.state.videos[0].filename){
                let title = this.state.videos[0].title !== this.state.videos[0].autor ? `${this.state.videos[0].autor} - ${this.state.videos[0].title}`:this.state.videos[0].autor;
                this.setState({
                    playingName: title,
                    playingUrl: this.state.videos[0].filename,
                    showPlayer: true,
                    playingIndex: 0
                });
            }
        });
    }

    changePlayingUrl(index) {
        if (this.state.videos.length && this.state.videos[index]) {
            let title = this.state.videos[index].title !== this.state.videos[index].autor ? `${this.state.videos[index].autor} - ${this.state.videos[index].title}`:this.state.videos[index].autor;
            this.setState({
                playingUrl: this.state.videos[index].filename,
                playingName: title,
                playingIndex: parseInt(index)
            });
        }
    }

    hidePlayer() {
        this.setState({
            showPlayer: false,
            videos: [],
            promoVideosBase: '',
            playingUrl: '',
            playingName: '',
            playingIndex: 0
        });
    }

    prepareData () {
        let playPromoInfo;

        playPromoInfo = {
            id: this.state.listObj.itemId !== '-1' ? this.state.listObj.itemId:'',
            name: this.state.listObj.name
        }
        let videos = [];

        if (this.state.videos.length && this.state.videos_ids.length) {

            let deletedVideos = this.state.videos.filter(video => video.deleted);

            let videosIds = JSON.parse(JSON.stringify(this.state.videos_ids));
            videosIds = videosIds.map((vid) => {
                vid.deleted = false;
                return vid;
            });

            if (deletedVideos.length) {

                deletedVideos.forEach((deleted) => {
                    let item = videosIds.filter(ids => deleted.id === ids.id);
                    if (item.length) {
                        item.forEach((value) => {
                            value.deleted = true;
                        });
                    }
                });
            }

            let videosPush = videosIds.filter(vid => !vid.deleted);

            if (videosPush.length) {
                videosPush.forEach((video, index) => {
                    let obj = {id: `${video.id}`, orden: index + 1};
                    if (video['pv_id']) {
                        obj['pv_id'] = video['pv_id'];
                    }
                    videos.push(obj);
                });

            }
        }
        // if(this.state.videos.length) {
        //     let videosPush = ItemFilter(this.state.videos, 'deleted', false);
        //     if(videosPush.length) {
        //         videosPush.forEach((video,index) => {
        //             let obj = {id: video.itemId, orden: index + 1};
        //             if (video['pv_id']) {
        //                 obj['pv_id'] = video['pv_id'];
        //             }
        //             videos.push(obj);
        //         })
        //     }
        // }

        let form = {
            playPromoInfo,
            promoInfo: {videos:videos}
        }
        return form;
    }

    getPromoDuration() {
        let time = this.state.listObj.total_duration.split(':');
        let minutes = parseInt(time[2]) > 30 ? parseInt(time[1]) + 1: parseInt(time[1]);
        minutes = minutes.toString().length === 1 ? `0${minutes}`:minutes.toString();
        let hour = `${time[0]} h ${minutes} min`;
        let videosLabel = this.state.listObj.count_videos === 0 ||
            this.state.listObj.count_videos > 1 ? 'videos':'video';
        return `${this.state.listObj.count_videos} ${videosLabel}, ${hour}`;
    }

    handleInputChange (value) {
        this.setState({secundaryView: false});
        let listObj = JSON.parse(JSON.stringify(this.state.listObj));
        listObj.name = value;

        this.setState({listObj, secundaryView: true}, () => {
            this.checkIfCanSave();
        });
    }

    addDefaultSrc(ev){
        ev.target.src = defaultThumbnail;
    }

    onVideoEnds() {
        let index = `${this.state.playingIndex + 1}`;

        this.changePlayingUrl(index);
    }

    setModalShowDrop(value) {
        if(value) {
            this.getDevicesList(() => {
                this.setState({modalShowDrop: value});
            });
        } else {
            this.setState({modalShowDrop: value});
        }

    }

    handleSubmit(data) {
        let notificationConfig = {
            title: "Atención!",
            message: 'Título y archivo de video son requeridos',
            type: "warning",
            insert: "bottom",
            container: "bottom-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
                duration: 1000,
                onScreen: true
            }
        };
        if(
            this.state.promoInfo.title &&
            this.state.promoInfo.timelapse &&
            this.state.promoInfo.file.length &&
            this.state.promoInfo.days.length &&
            this.state.promoInfo.devices_id.length &&
            this.state.promoInfo.start_time &&
            this.state.promoInfo.end_time
        ) {
            this.setState({isUploading: true});

            ConnectionsService.uploadPromo(this.state.promoInfo).then((response) => {
                this.setState({isUploading: false});
                notificationConfig.message = 'Tu promo fué subida correctamente';
                notificationConfig.type = "success";
                store.addNotification(notificationConfig);
                this.getPromo("");
                this.setModalShowDrop(false);
            },(error) => {
                this.setState({isUploading: false});
                notificationConfig.message = 'Error al intentar subir tu promo';
                notificationConfig.type = "danger";
                store.addNotification(notificationConfig);
            });
        } else {
            let titleTxt = !this.state.promoInfo.title ? 'Titulo ':'';
            let timelapseTxt = !this.state.promoInfo.timelapse ? 'Lapso de tiempo ':'';
            let videoTxt = !this.state.promoInfo.file.length ? 'archivo de video ':'';

            let daysTxt = !this.state.promoInfo.days.length ? 'Días ':'';
            let devicesTxt = !this.state.promoInfo.devices_id.length ? 'Dispositivos ':'';
            let startTxt = !this.state.promoInfo.start_time ? 'Hora inicial ':'';
            let endTxt = !this.state.promoInfo.end_time ? 'Hora final ':'';

            notificationConfig.message = `${titleTxt}${timelapseTxt}${videoTxt}${devicesTxt}${daysTxt}${startTxt}${endTxt} son requeridos`;
            store.addNotification(notificationConfig);
        }
    }

    handleChildren(data) {
        if(data.title && data.file.length) {
            this.setState({buttonShowDrop: true,promoInfo: data});
        } else {
            this.setState({buttonShowDrop: false});
        }
    }

    render() {
        const secundaryHeader = this.state.secundaryView ? (
            <TableEditor btnTitle="Agregar videos"
                details=''
                listObj={this.state.listObj}
                handleButton={this.editorBtnClicked}
                handleInput={this.handleInputChange}/>
        ):(null);

        const promoPromo = this.state.promo.length ? this.state.promo.map(video =>
            <TableItem srcIcon="playpromo"
                autor={video.count_videos ? `${video.count_videos} videos`:''}
                itemId={video.itemId}
                title={video.name}
                key={video.itemId}
                isChecked={video.isChecked}
                handleCheck={this.checkChild}
                handleItemClick={this.clickChild}>
                {
                    video.count_videos > 0 && (<button className="table-btn"
                        id={`add-${video.itemId}`}
                        onClick={(e) => {this.showPlayerModal(e,video.itemId)}}
                        disabled={this.state.isAjax}>
                        <SvgIcon srcIcon="play" width="35" height="35" fill={this.state.iconFill}/>
                        <span className="table-btn-span">Reproducir</span>
                    </button>)
                }
                {
                    // <button className="table-btn"
                    //     id={`add-${video.itemId}`}
                    //     onClick={(e) => {this.editItem(e,video.itemId)}}
                    //     disabled={this.state.isAjax}>
                    //     <SvgIcon srcIcon="edit" width="35" height="35" fill={this.state.iconFill}/>
                    //     <span className="table-btn-span">Editar</span>
                    // </button>
                }
                <button className="table-btn"
                    id={`delete-${video.itemId}`}
                    onClick={(e) => {this.deleteChild(e,video.itemId)}}
                    disabled={this.state.isAjax}>
                    <SvgIcon srcIcon="close" width="35" height="35" fill={this.state.iconFill}/>
                    <span className="table-btn-span">Eliminar</span>
                </button>
            </TableItem>
        ):(null);

        const promoVideosPlaceholder = !this.state.videos.length && this.state.secundaryView ? (
            <div className="w-100 h-100 d-flex align-items-center justify-content-center pt-5">
                <h3>
                    Esta promo aún no tiene videos asignados
                </h3>
            </div>
        ):(null);

        const promoVideos = this.state.videos.length ? this.state.videos.map((video, index) => {
            let vars = {
                autor: video.deleted ? `${video.autor} `:video.autor,
                itemId: video.itemId,
                title: video.title,
                key: index + 1,
                position: video.orden,
                srcIcon: "movielane",
                deleted: video.deleted,
                tags: video.tags
            }
            return (
                <TableItemCounter {...vars}>
                    <button className="table-btn" id={`add-${video.itemId}`}
                        onClick={() => {this.playVideo(video)}}>
                        <SvgIcon srcIcon="play" width="35" height="35" fill="#7F60EA"/>
                        <span className="table-btn-span">Reproducir</span>
                    </button>
                    <button className="table-btn"
                        id={`delete-${vars.itemId}`}
                        onClick={() => {this.deleteVideo(`${index}`)}}
                        disabled={this.state.isAjax}>
                        <SvgIcon srcIcon="close" width="35" height="35" fill={this.state.iconFill}/>
                        <span className="table-btn-span">Eliminar</span>
                    </button>
                </TableItemCounter>
            );
        }):(null);

        const promoNewVideos = this.state.newVideos.length ? this.state.newVideos.map((video,index) => {
            return (
                <TableItem srcIcon="movielane"
                    tags={video.tags}
                    autor={video.autor}
                    itemId={video.itemId}
                    title={video.title}
                    key={video.itemId}
                    isChecked={video.isChecked}
                    handleCheck={this.checkNewChild}/>
            );
        }):(null);

        const showPromo = this.state.videos.length ? this.state.videos.map((promo, index) => {
            let title = promo.title !== promo.autor ? `${promo.autor} - ${promo.title}`:promo.autor;
            return (
                <div className={`row m-0 mouse-pointer p-2 ${promo.filename === this.state.playingUrl ? 'on-playing-row':''}`} key={index} onClick={(e) => {this.changePlayingUrl(index)}}>
                    <div className="col-12 p-0">
                        <div className='row m-0 pb-2'>
                            <div className="col max-width-50px p-2">

                                <img src={defaultThumbnail} alt="" width="50"/>
                            </div>
                            <div className="col pr-0">
                                <span className="font-size-12 playing-title">{title}</span>
                                { promo.filename === this.state.playingUrl && (<span className="font-size-10 font-color-fff"><br/>Reproduciendo</span>)}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }):(null);

        return (
            <div className="Promo-container">
                <Dialog show={this.state.modalShow}
                    onHide={() => this.setModalShow(false)}
                    buttonTitle="Agregar video"
                    buttonShow={true}
                    isUploading={false}
                    buttonCallBack={this.handleSubmitPromo}>
                    <h4 className="text-center w-100"><strong>Agregar video</strong></h4>
                    <h6 className="text-center w-100">Selecciona uno o varios videos</h6>
                    <div className="p-3">
                        <div className='row'>
                            {/*<div className="col-1 p-0">
                                <button className="styless-btn w-100" onClick={this.filtersToggle}> <SvgIcon srcIcon="filter" width="35" height="35" fill="#7F60EA"/> Filtrar</button>
                            </div>*/}
                            <div className='col'>
                                <Searcher updateInput={this.handleVideoSearch} placeholder="Buscar video"/>
                            </div>
                            <div className="col-12">
                                <FiltersBox active={true}
                                    showCloseBtn={false}
                                    childrenData={this.handleTags}
                                    onHide={() => this.setState({showFilters: false})}/>
                            </div>
                        </div>
                    </div>
                    <div className="px-3">
                        <TableHeader updateCheck={this.checkAllPromo} isCheckedAll={this.state.isCheckedAllPromo}/>
                    </div>

                    <div className="px-3 modal-video-box">
                        {this.state.newVideos.length && !this.state.isVideoAjax ? promoNewVideos:(null)}
                        { this.state.isVideoAjax ? <LoadingBox animationType="loading"/>:(null) }
                    </div>
                    <div className="px-3">
                        {this.state.totalVideos > this.state.perPage ? (
                            <ReactPaginate previousLabel={'Anterior'}
                                nextLabel={'Siguiente'}
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={this.state.pageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={this.handlePageClick}
                                containerClassName={'pagination'}
                                subContainerClassName={'pages pagination'}
                                activeClassName={'active'}/>
                        ):(null)}
                    </div>
                </Dialog>

                <Dialog show={this.state.showPlayerDetails}
                    onHide={() => this.setState({showPlayerDetails: false})}
                    buttonTitle="Subir video"
                    buttonShow={false}
                    isUploading={false}>
                    <h4 className="text-center">{this.state.playingName}</h4>
                    <ReactPlayer controls={true} url={this.state.playingUrl} playing={this.state.showPlayerDetails} width='100%' height='calc(100% - 50px)' />
                </Dialog>

                <Dialog show={this.state.showPlayer}
                    onHide={() => this.hidePlayer()}
                    buttonTitle="Subir video"
                    buttonShow={false}
                    isUploading={false}>


                    <div className="row m-0">
                        <div className="col-12 col-sm-7">
                            <h4 className="text-center">{this.state.playingName}</h4>
                            <div className="row m-0 pt-4">
                                <div className="col-12 p-0 text-center">
                                    <ReactPlayer controls={true}
                                        url={this.state.playingUrl}
                                        playing={this.state.showPlayer}
                                        className="video-player-setts"
                                        onEnded={() => {this.onVideoEnds()}}/>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-5 pt-3">
                            <h5>Promo</h5>

                            <div className="row m-0 promo-container">
                                <div className="col-12 p-0">
                                    {showPromo}
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog>

                <Dialog show={this.state.modalShowDrop}
                    onHide={() => this.setModalShowDrop(false)}
                    buttonTitle="Subir promo"
                    buttonShow={this.state.buttonShowDrop}
                    isUploading={this.state.isUploading}
                    buttonCallBack={this.handleSubmit}>
                    <DropPromo childrenData={this.handleChildren} isUploading={this.state.isUploading} devices={this.state.devices}/>
                </Dialog>

                <div className="row m-0 pb-4">
                    {
                        this.state.secundaryView ? (
                            <div className="col-1 p-0 w-100 d-flex align-items-center max-width-35px">
                                <button className="btn btn-default p-0" onClick={() => {this.setState({secundaryView: false})}}>
                                    <SvgIcon srcIcon="left" width="35px"/>
                                </button>
                            </div>
                        ):(null)
                    }
                    <div className={`${this.state.secundaryView ? "col-10 pl-2 pr-0":"col-12 p-0"} col-md w-100 d-flex align-items-center`}>
                        <h4 className="mb-0">
                            Mis promos
                        </h4>
                    </div>
                    {
                        !this.state.isEdit && !this.state.secundaryView ? <div className="col-12 col-md-3 pb-2 pb-md-0 pt-2 pt-md-0">
                            <Searcher updateInput={this.handlePromoSearch} placeholder="Buscar promo"/>
                        </div>:(null)
                    }
                    <div className="col-12 pr-md-0 col-md-3 col-lg-2">
                        {
                            !this.state.secundaryView ? (
                                <button type="button"
                                    className="btn-blank w-100 blank-bg toggle-content d-flex align-items-center justify-content-center"
                                    onClick={this.newPromo}>
                                    <SvgIcon srcIcon="playpromo" width="28" height="28" fill="#7F60EA"/>
                                    <span className="pl-1">Nueva promo</span>
                                </button>
                            ):(
                                <button type="button" className="btn-standard w-100 success-bg toggle-content" onClick={this.handleSubmitPromo} disabled={this.state.isSaveDisabled}>
                                    <span>Guardar</span>
                                </button>
                            )
                        }
                    </div>
                </div>

                <div className="row m-0">
                    {
                        !this.state.secundaryView ? (
                            <TableHeader updateCheck={this.checkAll} isCheckedAll={this.state.isCheckedAll}>
                                <button className="table-btn" id="delete-all" onClick={this.deleteAll}>
                                    <SvgIcon srcIcon="close" width="35" height="35" fill={this.state.iconFill}/>
                                    <span className="table-btn-span">Eliminar</span>
                                </button>
                            </TableHeader>
                        ):(secundaryHeader)
                    }
                </div>

                <div className="row m-0 Promo-promo-container">
                    {
                        !this.state.isSearching && this.state.promo.length && !this.state.secundaryView ? promoPromo:(null)
                    }

                    {
                        !this.state.isSearching && this.state.videos.length && this.state.secundaryView ? promoVideos:(null)

                    }

                    {
                        !this.state.isSearching && this.state.secundaryView && !this.state.videos.length ? promoVideosPlaceholder:(null)
                    }

                    {
                        this.state.isSearching ? (
                            <LoadingBox animationType="loading"/>
                        ):(null)
                    }
                </div>


                {this.state.totalPromo > this.state.perPagePL && !this.state.secundaryView ? (
                    <ReactPaginate previousLabel={'Anterior'}
                        nextLabel={'Siguiente'}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={this.state.pageCountPL}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={this.handlePageClickPL}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}/>
                ):(null)}

                {this.state.totalVideosPromo > this.state.perPageVideosPromo && this.state.secundaryView ? (
                    <ReactPaginate previousLabel={'Anterior'}
                        nextLabel={'Siguiente'}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={this.state.pageCountVideosPromo}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={this.handlePageClickVideosPromo}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'active'}/>
                ):(null)}
            </div>
        );
    }
}
export default Promo;
